import { EIDAClientProfile } from "@eres/ssoapi/entities";
import { SSORegContext, Step } from "@my-dld/contexts/RegisterContext";
import React, { Component } from "react";
import { StringUtil } from "@eres/core";
import TextInputField from "@my-dld/components/Form/TextInputField";
import Strings from "@my-dld/assets/strings";

interface ProfileProp {
	profile: EIDAClientProfile;
	onChange: () => void;
	onProceed: ( profile: EIDAClientProfile ) => void;
	step: Step,
}

interface ProfileState extends EIDAClientProfile {
	editableEmail: boolean;
	formErrors: { [ k: string ]: string | undefined };
}

class ProfileInfo extends Component<ProfileProp, ProfileState> {
	static contextType = SSORegContext;
	context!: React.ContextType<typeof SSORegContext>;

	constructor( props: ProfileProp ) {
		super( props );
		this.state = {
			formErrors: {},
			...this.props.profile,
			editableEmail: props.profile && StringUtil.isEmptyStringOrNull( props.profile.email ),
		};
	}

	componentDidMount() {
		if ( !this.state.editableEmail && this.context.newEmail != null ) {
			this.setState( {
				editableEmail: true,
				email: this.context.newEmail,
			} );
		}
	}

	componentDidUpdate( prevProps: Readonly<ProfileProp>, prevState: Readonly<ProfileState>, snapshot?: any ) {
		if ( prevProps.profile !== this.props.profile ) {
			this.setState( {
				...this.props.profile,
			} );
		}
	}

	isValid = () => {
		let isError = false;
		if ( this.state.editableEmail ) {
			isError = isError || StringUtil.isEmptyStringOrNull( this.state.email );
		}
		if ( !isError ) {
			const evs = Object.values( this.state.formErrors );
			isError = evs.filter( x => !StringUtil.isEmptyStringOrNull( x ) ).length !== 0;
		}
		return !isError;
	};

	render() {
		const { formErrors, editableEmail } = this.state;
		const isValid = this.isValid();
		const kProp = { holder: this, disabled: true, containerClassName: "col-md-6" };
		return <>
			<div className={ "personal-details-verify" }>
				<TextInputField
					mode={ "text" }
					id={ "emiratesId" }
					{ ...kProp }
					containerClassName={ "col-md-12 eid-column" }
					label={ Strings.emirates_id }
				>
					{ this.props.step === Step.confirm &&
						<button
							className="btn btn-link eid-change-btn"
							onClick={ this.props.onChange }>{ Strings.change_eid }</button>
					}
				</TextInputField>
				<TextInputField
					mode={ "text" }
					id={ "fullNameAr" }
					{ ...kProp }
					containerClassName={ "col-md-12" }
					label={ Strings.name_arabic }
				/>
				<TextInputField
					id={ "fullNameEn" }
					mode={ "text" }
					{ ...kProp }
					containerClassName={ "col-md-12" }
					label={ Strings.name_english }
				/>
				<TextInputField
					id={ "mobileNumber" }
					mode={ "text" }
					{ ...kProp }
					containerClassName={ "col-md-12" }
					label={ Strings.mobile_number }
				/>
				<TextInputField
					id={ "email" }
					{ ...kProp }
					containerClassName={ "col-md-12" }
					mode={ editableEmail ? "input" : "text" }
					disabled={ !editableEmail }
					error={ formErrors.email }
					label={ Strings.email }
					required={ editableEmail }
					onValueChange={ ( value, extra ) => {
						this.validateEmail( value );
					} }
				/>
			</div>
			{ this.props.step === Step.confirm && <>
                <button
                    className="btn btn_1 btn_style1" disabled={!isValid}
                    onClick={this.onConfirm}>{Strings.proceed}</button>
				<div className="privacy-policy-text">{ Strings.proceed_aggrements }</div>
			</>
			}
			{ this.props.step === Step.profile_confirm && <>
                <button
                    className="btn btn_1 btn_style1" disabled={!isValid}
                    onClick={this.onConfirm}>{Strings.proceed}</button>
			</>
			}
		</>;
	}

	onConfirm = () => {
		const p = this.props.profile;
		if ( this.state.editableEmail ) {
			p.email = this.state.email;
			this.context.update!( { newEmail: p.email } );
		}
		this.props.onProceed( p );
	};
	setError = ( key: string, error: string | undefined ) => {
		this.setState( s => {
			return {
				formErrors: {
					...s.formErrors,
					[ key ]: error,
				}
			};
		} );
	};
	validateEmail = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( "email", Strings.form_required_label );
		} else if ( !StringUtil.isEmailAddress( value ) ) {
			this.setError( "email", Strings.invalid_email_address );
		} else {
			this.setError( "email", undefined );
		}
	};
}

export default ProfileInfo;
